<!--
 * @Author: lyodon.li lyodon.li@feisu.com
 * @Date: 2025-02-14 16:22:17
 * @LastEditors: lyodon.li lyodon.li@feisu.com
 * @LastEditTime: 2026-02-11 15:16:53
 * @FilePath: /designcenter/src/App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->

<template>
  <div class="loading-container" v-if="!isInitialized">Loading...</div>
  <div v-else>
    <RouterView />
  </div>
</template>

<script setup lang="ts">
import { onMounted, nextTick, watch, onUnmounted, ref } from 'vue'
import { useRoute, useRouter } from 'vue-router'
import { initProject } from '@/api/modules/project'
import { useHeaderStore } from '@/store/header'
import { useProjectStore } from '@/store/project'
import { storeToRefs } from 'pinia'
import { Cookie, handleFsLink, setLoginUrl, parseUrlParams } from '@/utils'
import * as Sentry from '@sentry/vue'
import { useUserStore } from '@/store/user'
import { PageTimeTracker } from '@/utils/analytics'
const headerStore = useHeaderStore()
const projectStore = useProjectStore()
const route = useRoute()
const router = useRouter()
const userStore = useUserStore()

const isShare = ref(false)

const { isInitialized } = storeToRefs(projectStore)
let tracker: PageTimeTracker | null = null
// TODO: 权限校验应该在路由拦截器里面执行，并应该放在 App 的 onMounted 里面执行
onMounted(async () => {
  await router.isReady()
  await nextTick()
  // 使用优化后的 parseUrlParams 处理 URL 参数（支持 HTML 实体编码如 &amp;）
  const urlParams = parseUrlParams()
  const token = Cookie.get('token_new') || route.query.token || urlParams.token || ''

  projectStore.setCurrentProjectId(null)
  projectStore.setCurrentTemplateId(null)
  console.log('token', token)

  if (token) {
    if (import.meta.env.MODE == 'production') {
      tracker = new PageTimeTracker('Design Center')
    }
    localStorage.setItem('token_new', token)
    // 检查是否为分享链接（同时存在 projectId 和 share 参数）
    // const shareParam = urlParams.share
    const hasRouteQuery = Object.keys(route.query).length > 0
    const urlParams = hasRouteQuery ? route.query : parseUrlParams()
    const projectIdParam = urlParams.projectId

    // 只有在有 URL 参数且 share=1 时才走分享逻辑
    isShare.value = hasRouteQuery && Boolean(urlParams.share)

    // 处理 projectIdParam 可能为 string | string[] | null 的情况
    const projectIdStr = Array.isArray(projectIdParam) ? projectIdParam[0] : projectIdParam
    const projectId = projectIdStr ? parseInt(projectIdStr, 10) : NaN
    if (!isNaN(projectId) && projectId > 0) {
      projectStore.setCurrentProjectId(projectId)
    }

    if (isShare.value) {
      projectStore.$patch(state => {
        state.isInitialized = true
      })
    } else {
      await initProject()
        .then((res: unknown) => {
          if (res.data.projectId) {
            projectStore.setCurrentProjectId(res.data.projectId)
            projectStore.$patch(state => {
              state.isInitialized = true
            })
            if (res.data.templateId || (res.data.templateId === 0 && res.data.isCustomized === 1)) {
              projectStore.setCurrentTemplateId(res.data.templateId)
            } else {
              if (route.path === '/design-center') {
                nextTick(() => {
                  headerStore.showSelectTemplatePopup()
                })
              }
            }
          }
        })
        .catch(error => {
          console.log(error)
        })
    }
  } else {
    if (
      location.host.includes('whgxwl.com') ||
      location.host.includes('design-center') ||
      location.host.includes('feisu')
    ) {
      console.log(handleFsLink(`/login.html?redirect=${setLoginUrl()}`), 'localtion')
      location.href = handleFsLink(`/login.html?redirect=${setLoginUrl()}`)
    }
  }
})
onUnmounted(() => {
  if (tracker) {
    tracker.destroy()
  }
})
watch(
  () => userStore.userInfo,
  userInfo => {
    if (userInfo) {
      Sentry.setUser({
        username: userStore?.userInfo?.customers_firstname + ' ' + userStore?.userInfo?.customers_lastname,
        email: userStore?.userInfo?.customers_email_address,
      })
    }
  },
  { immediate: true }
)
</script>

<style lang="scss">
#mainApp {
  height: 100vh;
  width: 100vw;
}
</style>

<style lang="scss" scoped>
.loading-container {
  height: 100vh;
  width: 100vw;
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  @include font14;
}
</style>
